// @flow
import React from 'react';
import type { Node } from 'react';
import { MdClose, MdDelete } from 'react-icons/lib/md';
import PopupHeader from '../PopupHeader';
import PopupFooter from '../PopupFooter';
import PopupHeaderRightGroup from '../PopupHeaderRightGroup';
import PopupContent from '../PopupContent';
import PopupContainer from '../PopupContainer';
import PopupHeaderTitle from '../PopupHeaderTitle';
import Button from '../Button';
import PopupCloseButton from '../PopupCloseButton';
import styles from './confirmDeletionPopup.css';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
import { Cancel, Delete } from '../CommonTexts';

type ConfirmDeletionPopupPropTypes = {
  onConfirm: Function,
  title?: string,
  descriptionText?: Node,
  loading?: boolean,
};

const ConfirmDeletionPopup = ({
  onConfirm,
  title = '',
  descriptionText = '¿Esta seguro de querer borrar el objeto?',
  loading = false,
}: ConfirmDeletionPopupPropTypes) => (
  <PopupContainer>
    <PopupHeader size="small">
      <PopupHeaderLeftGroup>
        <PopupHeaderTitle title={title} size="big" />
      </PopupHeaderLeftGroup>
      <PopupHeaderRightGroup>
        <PopupCloseButton
          size="small"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </PopupHeaderRightGroup>
    </PopupHeader>
    <PopupContent size="small">
      <div className={styles.deleteConfirmContent}>
        <h1>
          {descriptionText}
        </h1>
        <br />
      </div>
    </PopupContent>
    <PopupFooter size="small" align="center">
      <PopupCloseButton
        title={Cancel()}
        tint="paleGray"
      />
      <Button
        className={styles.deleteConfirmButton}
        onClick={onConfirm}
        isLoading={loading}
        tint="error"
        title={Delete()}
        Icon={MdDelete}
        iconPosition="right"
      />
    </PopupFooter>
  </PopupContainer>
);

export default ConfirmDeletionPopup;



// WEBPACK FOOTER //
// ./src/scripts/components/ConfirmDeletionPopup/index.jsx